<template>
    <img
        v-if="thumbnail"
        :src="thumbnail"
        class="file-thumbnail"
        alt="thumbnail"
        :data-id="item.id"
    />

    <div v-else v-html="createSkeletonThumbnail"></div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Thumbnail",
    data() {
        return {
            thumbnail: null
        }
    },
    props: {
        item: Object,
    },

    async created() {
        if (!this.item) return;
        await this.loadThumbnail();
    },

    destroyed() {
        if (this.thumbnail) URL.revokeObjectURL(this.thumbnail);
    },

    computed: {
        createSkeletonThumbnail() {
            return window.UI.createFileThumbnailPlaceholder();
        },
    },

    methods: {
        async loadThumbnail() {
            if (this.item.thumbnail) this.thumbnail = URL.createObjectURL(this.item.thumbnail);
            else if (this.item.thumbnailBlob) this.thumbnail = URL.createObjectURL(this.item.thumbnailBlob);
        }
    }
}
</script>

<style scoped>

</style>
